import { html } from 'lit';
import { repeat } from 'lit/directives/repeat.js';
import { ConnectCustomersController } from '../../lib/controllers/connect-customers.js';
import { BaseElement } from '../base.js';

export class ConnectAccountCustomers extends BaseElement {
  static properties = {
    account: { attribute: true },
    item: {}
  };

  constructor() {
    super();
    this.account = '';
    this.item = null;
    this.filter = 'ALL';
    this.customers = new ConnectCustomersController(this);
  }

  render() {
    return this.customers.render((customers) => {
      return html`
        <ul class="nav nav-tabs mb-3">
          ${repeat(
            [
              ['ALL', 'all'],
              ['ACTIVE', 'active'],
              ['PENDING', 'pending'],
              ['INACTIVE', 'inactive']
            ],
            ([status, label]) => this.renderFilter(status, label)
          )}
        </ul>
        ${customers.length
          ? html`
              <div
                class="row row-cols-1 row-cols-md-2 row-cols-lg-1 row-cols-xl-2 g-4"
              >
                ${customers
                  .filter(
                    ({ status }) =>
                      this.filter === 'ALL' || status === this.filter
                  )
                  .map(customerCard())}
              </div>
            `
          : html`<h6>There are no customers yet</h6>`}
      `;
    });
  }

  renderFilter(status, label) {
    const { filter } = this;
    return html`
      <li class="nav-item">
        <a
          class="nav-link ${filter === status ? 'active' : ''}"
          href="#"
          @click=${(e) => this.showStatus(status, e)}
        >
          ${label}
        </a>
      </li>
    `;
  }

  showStatus(status, event) {
    event.preventDefault();
    this.filter = status;
    this.requestUpdate();
  }
}

function customerCard() {
  return (customer) => {
    const { suspended, sites } = customer;
    const suspended_count = sites?.filter((site) => site.suspended).length;
    const sites_link = `/accounts/${customer.account}/suppliers/${customer.supplier_id}/`;
    return html`
      <div class="col">
        <div class="card">
          <div class="card-header hstack gap-3">
            <h5 class="mb-0 me-auto text-truncate">${customer.name}</h5>
            ${suspended
              ? html`
                  <small class="badge text-bg-danger fw-normal">
                    Suspended
                  </small>
                `
              : ''}
            ${suspended_count
              ? html`
                  <small class="badge text-bg-warning fw-normal">
                    Part Suspended
                  </small>
                `
              : ''}
          </div>
          <div class="card-body vstack gap-2">
            <small>
              ${statusIcon(customer.status)} Status:
              <strong class="text-${statusColor(customer.status)}">
                ${customer.status}
              </strong>
            </small>
            <small>
              <i class="bi bi-hash"></i>
              Customer ID:
              ${customer.customer_id
                ? html`
                    <shared-copy-id id=${customer.customer_id}></shared-copy-id>
                  `
                : html`<span class="text-muted">none</span>`}
            </small>
            <small>
              <i class="bi bi-building"></i>
              <a href="/accounts/${customer.account}/" class="link">
                Manage Account
              </a>
            </small>
            <div class="hstack">
              <small class="me-auto">
                <i class="bi bi-${sites ? 'building' : 'truck'}"></i>
                <a href="${sites_link}">
                  ${sites
                    ? html`Manage ${sites.length} sites`
                    : html`Manage Supplier`}
                </a>
                ${suspended_count
                  ? html`
                      <small class="me-auto">
                        (${suspended_count} suspended)
                      </small>
                    `
                  : ''}
              </small>
            </div>
          </div>
        </div>
      </div>
    `;
  };
}

function statusIcon(status) {
  return html`
    <i class="bi bi-circle-fill me-1 text-${statusColor(status)}"></i>
  `;
}

function statusColor(status) {
  switch (status) {
    case 'PENDING':
      return 'warning';
    case 'ACTIVE':
      return 'success';
    default:
      return 'danger';
  }
}

customElements.define('connect-account-customers', ConnectAccountCustomers);
